import { FriendDefaultArgs, FriendGetPayload } from '@repo/database/src/types';

export const friendWithIncludes = {
  include: {
    friend: {
      select: {
        id: true,
        firstName: true,
        lastName: true,
        alias: true,
        smartWalletAddress: true,
        seats: {
          where: {
            table: {
              deletedAt: null,
            },
          },
          orderBy: {
            createdAt: 'desc',
          },
          select: {
            table: {
              select: {
                id: true,
                name: true,
                game: true,
                maxPlayers: true,
                seats: true,
              },
            },
          },
        },
      },
    },
  },
} satisfies FriendDefaultArgs;
export type FriendWithIncludes = FriendGetPayload<typeof friendWithIncludes>['friend'];
